import jobRepository from './jobRepository';
import SearchFormRepository from './SearchFormRepository';
import SearchJobRepository from './SearchJobRepository';

export default {
  'jobs' : jobRepository,
  'search-form' : SearchFormRepository,
  'search-job' : SearchJobRepository,
}
